import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon ,MDBRow, MDBCol,MDBDataTable    } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaladdexpert from './Modaladdexpert';
import Modaleditexpert from './Modaleditexpert';
import Modaldateopen from './Modaldateopen';




export default class Superadmindateopen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
           this.checkdate = this.checkdate.bind(this);
      }


    componentDidMount() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectdateopen')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      list() {

        setTimeout(() => {
          api.get('registercon/selectdateopen')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

     
       checkdate = (event,event2) => {
       
      const date = new Date();
      const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
      const dates = day+"-"+month+"-"+year ;

      const dateFrom = event;
      const dateTo = event2;
     // const dateTo = "10-11-2024";
      const dateCheck = dates;

      const d1 = dateFrom.split("-");
      const d2 = dateTo.split("-");
      const c = dateCheck.split("-");

      const from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
      const to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
      const check = new Date(c[2], parseInt(c[1])-1, c[0]);
      const checkshow = check >= from && check <= to;

      if (checkshow === true) {
        return <div>{event2}</div>;
      }else{
        return <div>ระบบปิดแล้ว </div>;
      }
        
        }

    render() {

    

//console.log(checkshow)


      const datast = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'รายการ',
            field: 'name_expert',
            sort: 'name_expert',
            width: 150
          },
          {
            label: 'วันที่ปิด',
            field: 'username_expert',
            sort: 'username_expert',
            width: 150
          },
          {
            label: 'รายการ',
            field: 'password_expert',
            sort: 'password_expert',
            width: 150
          },
         
          {
            label: 'จัดการ',
            field: 'name_admin2',
            sort: 'name_admin2',
            width: 150
          },
          
      
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
     
          
          {
            
             list: <>{i+1}</>,
             name_expert: <>{data.name_dateopen}</>,
             username_expert: <>
             {this.checkdate(data.start_dateopen,data.close_dateopen)}
             </>,
             password_expert: <>
            {data.type_dateopen}
             </>,
           
             name_admin2: <><Modaldateopen id_dateopen={data.id_dateopen} name_dateopen={data.name_dateopen} start_dateopen={data.start_dateopen} list={this.list} /></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            theadColor="grey lighten-1"
            />

        return (
            <MDBContainer fluid>
            <div>
        
            {localStorage.getItem('admin_type') === 'expertbn' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (บรรณาธิการ)</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
               <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}    
                    <MDBRow >
                        <MDBCol md="8">
                        <PageHeader
                            className="site-page-header"
                          // onBack={() => null}
                            title="ข้อมูลวันเปิด-ปิด"
                            subTitle="ข้อมูลวันเปิด-ปิด"
                            avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                        />
                        </MDBCol>
                        <MDBCol md="4">
                        {/* <Modaladdexpert iduser={localStorage.getItem('iduser')} list={this.list} /> */}
                        </MDBCol>
                    </MDBRow>
   </MDBAlert>
    {persons}
    {/*    
                <MDBTable responsive>
                    <MDBTableHead color='light'>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>สังกัดหน่วยงาน</th>
                        <th>ความเชียวชาญ</th>
                        <th>เบอร์โทร</th>
                        <th>ผู้เพิ่มข้อมูล</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_expert}</td>
                        <td>{article.username_expert}</td>
                        <td>{article.password_expert}</td>
                        <td>{article.affiliation_expert}</td>
                        <td>{article.expertise_expert}</td>
                        <td>{article.tel_expert}</td>
                        <td>{article.name_admin}</td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
